"use client"
import Icon from '@components/icon'
import Link from 'next/link'
import React, { useEffect, useState } from 'react'
import styles from './category.module.scss'
import Hub, { IHubStation } from './hub'

// The favourites list lives in localStorage, so this page can't be rendered on
// the server the way the other categories are. It ships the full station index
// (id/name/url/blurb only) and picks out the saved ids on mount — which also
// means the hub behaves identically here to everywhere else.
export default function Favorites({ allStations }: { allStations: IHubStation[] }) {
    const [stations, setStations] = useState<IHubStation[] | null>(null)

    useEffect(() => {
        let saved: string[] = []
        try {
            saved = JSON.parse(localStorage.getItem('favorites') || '[]')
        } catch {
            saved = []
        }
        const byId = new Map(allStations.map(station => [station.id, station]))
        // Saved order is most-recent-first, and that's the order to keep — it is
        // the only ordering signal a personal list has.
        setStations(saved.map(id => byId.get(id)).filter(Boolean) as IHubStation[])
    }, [allStations])

    // `null` is the pre-mount state: render nothing rather than flashing the
    // "no favourites yet" panel at someone who has twenty of them.
    if (stations === null) return null

    if (!stations.length) return (
        <div className={styles.noFavorites}>
            <Icon icon={['fas', 'heart']} />
            <h2>אין עדיין תחנות מועדפות</h2>
            <h3>סמנו ״הוספה למועדפים״ בתחנות הרדיו ותוכלו לגשת אליהן בצורה מהירה בעתיד מכל מקום באתר</h3>
            <Link href="/category/top/" className={styles.cta}>
                לרשימת התחנות המובילות
            </Link>
        </div>
    )

    return <Hub stations={stations} />
}
